// Post display-title rules, shared by the posts modal and the Posting-Plan so the same
// post is labeled identically everywhere. Extracted from NewsPostsModal.

// Check if a title is a valid custom title (not a default/placeholder)
export function isValidTitle(title: string | null | undefined): boolean {
  if (!title) return false
  const invalidTitles = ['Untitled Post', 'Pillar Post', '']
  return !invalidTitles.includes(title.trim())
}

// Extract first sentence from content as title fallback
// Removes markdown formatting and extracts up to first sentence boundary (. ! ?)
export function extractTitleFromContent(content: string | null | undefined): string {
  if (!content) return "Untitled Post"

  // Remove markdown bold markers (**text** or __text__)
  let cleanText = content.replace(/\*\*([^*]+)\*\*/g, '$1').replace(/__([^_]+)__/g, '$1')

  // Trim leading whitespace and newlines
  cleanText = cleanText.trim()

  // Find first sentence boundary (. ! ? followed by space or end)
  const sentenceMatch = cleanText.match(/^(.+?[.!?])(?:\s|$)/)
  if (sentenceMatch) {
    const title = sentenceMatch[1].trim()
    // Limit to reasonable length (max 100 chars)
    return title.length > 100 ? title.substring(0, 97) + '...' : title
  }

  // If no sentence boundary, take first line (up to first newline)
  const firstLine = cleanText.split('\n')[0].trim()
  if (firstLine) {
    return firstLine.length > 100 ? firstLine.substring(0, 97) + '...' : firstLine
  }

  return "Untitled Post"
}
